class BaseModel {
  toJSON(options = {}) {
    return {
      error: 'Base serialize not overridden',
    };
  }
}

module.exports = BaseModel;
